// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191')
];

export const server_loads = [];

export const dictionary = {
		"/": [41],
		"/(authed)/analysis/clients": [42,[2,3],[,4]],
		"/(authed)/analysis/clients/[client_id]/analysis/graphs": [43,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/analysis/yearly": [44,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/bank": [45,[2,3,5,6],[,4]],
		"/(authed)/analysis/clients/[client_id]/bank/account-mapping": [46,[2,3,5,6],[,4]],
		"/(authed)/analysis/clients/[client_id]/bank/statement": [47,[2,3,5,6],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/accounting-units": [48,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/accounts": [49,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/accounts/[account]": [50,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/accrual-controls": [51,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/bank": [52,[2,3,5,7,8],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/common-searches": [53,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/explore": [54,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/key-figures": [55,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/monthly": [56,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/sampling": [57,[2,3,5,7,9],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/sampling/[sample_id]": [58,[2,3,5,7,9,10],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/sampling/[sample_id]/carousel": [59,[2,3,5,7,9,10],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/sampling/[sample_id]/summary": [60,[2,3,5,7,9,10],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/taxes/manual-vat": [61,[2,3,5,7,11],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/taxes/paye": [62,[2,3,5,7,11],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/taxes/tax-account": [63,[2,3,5,7,11],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/taxes/vat": [64,[2,3,5,7,11],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/voucher-series": [65,[2,3,5,7],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/vouchers": [66,[2,3,5,7,12],[,4]],
		"/(authed)/analysis/clients/[client_id]/book-years/[book_year]/vouchers/[voucher_id]": [67,[2,3,5,7,12],[,4]],
		"/(authed)/analysis/clients/[client_id]/data/taxes/paye": [68,[2,3,5,13],[,4]],
		"/(authed)/analysis/clients/[client_id]/data/taxes/vat": [69,[2,3,5,13],[,4]],
		"/(authed)/analysis/clients/[client_id]/recurring-searches": [70,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/reports/balance-sheet": [71,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/reports/cash-flow-statement": [72,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/reports/profit-and-loss-sheet": [73,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/sampling": [74,[2,3,5,14],[,4]],
		"/(authed)/analysis/clients/[client_id]/search": [75,[2,3,5],[,4]],
		"/(authed)/analysis/clients/[client_id]/taxes": [76,[2,3,5,15],[,4]],
		"/(authed)/analysis/clients/[client_id]/taxes/unchecked-tax": [77,[2,3,5,15],[,4]],
		"/(authed)/analysis/clients/[client_id]/transactions": [78,[2,3,5],[,4]],
		"/(authed)/audit/cases": [79,[2,16]],
		"/(authed)/audit/cases/[case_id]/acceptance": [80,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/acceptance/engagement-letter": [81,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/acceptance/opening-balances": [82,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/administrative-handling/administration": [83,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/administrative-handling/noted-management-procedures": [84,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/base-information/company-information": [85,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/base-information/company-selections": [86,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/base-information/natural-persons": [87,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/data/account-balance": [88,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/data/account-mapping": [89,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/data/files": [90,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/data/request-documents": [91,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/data/sie": [92,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/internal-controls/inventory": [93,[2,16,17,18]],
		"/(authed)/audit/cases/[case_id]/internal-controls/routines": [94,[2,16,17,18]],
		"/(authed)/audit/cases/[case_id]/planning": [95,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/planning/materiality": [96,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/planning/time-planning": [97,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/archive": [98,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/audit_report": [99,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/insights": [100,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/reports": [101,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/subsequent-events": [102,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/summary": [103,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/reporting/written_representation": [104,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/risk-assessment": [105,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/risk-assessment/material-accounts": [106,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/risk-assessment/material-accounts/add-procedures": [107,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/risk-assessment/risk-library": [108,[2,16,17]],
		"/(authed)/audit/cases/[case_id]/risk-handling": [109,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/noted-focus-area-procedures": [111,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/noted-procedures": [112,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/noted-report-level": [113,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/noted-transactions": [114,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/other": [115,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/report-level/other-groups": [116,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/report-level/risks": [117,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/report-level/transactions": [118,[2,16,17,19]],
		"/(authed)/audit/cases/[case_id]/risk-handling/[group]": [110,[2,16,17,19]],
		"/document-validation": [180],
		"/(authed)/files/clients/[client_id]/files": [119,[2,20,21,22]],
		"/(authed)/files/clients/[client_id]/files/[file_id]": [120,[2,20,21,22]],
		"/(authed)/files/clients/[client_id]/references/[reference]/files": [121,[2,20,21,23,24]],
		"/(authed)/files/clients/[client_id]/references/[reference]/files/[file_id]": [122,[2,20,21,23,24]],
		"/(authed)/files/clients/[client_id]/references/[reference]/new-files": [123,[2,20,21,23]],
		"/(authed)/files/clients/[client_id]/references/[reference]/new-files/[file_id]": [124,[2,20,21,23]],
		"/(authed)/firm": [125,[2,25]],
		"/(authed)/firm/clients/[client_id]/(base)/account-mapping": [126,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/book-year-settings": [127,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/book-years": [128,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/cases": [129,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(no-ledger)/cases/no-ledger/[case_id]": [138,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/company-information": [130,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/employees": [131,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/engagement-letter": [132,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/group-structure": [133,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/integrations": [134,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/natural-persons": [135,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/permanent-audit-files": [136,[2,25,26]],
		"/(authed)/firm/clients/[client_id]/(base)/remove-client": [137,[2,25,26]],
		"/(authed)/firm/employers": [139,[2,25]],
		"/(authed)/firm/employers/[employer_id]/administration/account-settings": [146,[2,25,27,30]],
		"/(authed)/firm/employers/[employer_id]/administration/employer-settings": [147,[2,25,27,30]],
		"/(authed)/firm/employers/[employer_id]/audit-collaboration-exchange/firm": [148,[2,25,27,31]],
		"/(authed)/firm/employers/[employer_id]/audit-collaboration-exchange/general-info": [149,[2,25,27,31]],
		"/(authed)/firm/employers/[employer_id]/audit-collaboration-exchange/new-request": [150,[2,25,27,31]],
		"/(authed)/firm/employers/[employer_id]/audit-collaboration-exchange/ongoing": [151,[2,25,27,31]],
		"/(authed)/firm/employers/[employer_id]/audit-collaboration-exchange/others": [152,[2,25,27,31]],
		"/(authed)/firm/employers/[employer_id]/(clients)/cases": [140,[2,25,27,28,29]],
		"/(authed)/firm/employers/[employer_id]/(clients)/cases/external": [141,[2,25,27,28,29]],
		"/(authed)/firm/employers/[employer_id]/(clients)/cases/finished": [142,[2,25,27,28,29]],
		"/(authed)/firm/employers/[employer_id]/(clients)/cases/new-case": [143,[2,25,27,28,29]],
		"/(authed)/firm/employers/[employer_id]/(clients)/client-processes": [144,[2,25,27,28]],
		"/(authed)/firm/employers/[employer_id]/(clients)/clients": [145,[2,25,27,28]],
		"/(authed)/firm/onboarding/clients/[client_id]/[activity=onboarding_activity]": [153,[2,25,32]],
		"/(authed)/firm/terms": [154,[2,25,33]],
		"/(authed)/firm/terms/condition": [155,[2,25,33]],
		"/(authed)/firm/terms/integrity-policy": [156,[2,25,33]],
		"/(authed)/firm/terms/personal-data-processing": [157,[2,25,33]],
		"/(authed)/firm/terms/personal-data-service": [158,[2,25,33]],
		"/(authed)/firm/terms/pre-approved-subprocessors": [159,[2,25,33]],
		"/fortnox": [181],
		"/guests/confirm_identity": [182,[39]],
		"/guests/create_firm": [183,[39]],
		"/guests/external_coworker": [184,[39]],
		"/guests/integrations": [185,[39]],
		"/guests/sign_document": [186,[39]],
		"/guests/sign_up": [187,[39]],
		"/(authed)/inactivated": [160,[2]],
		"/login": [188,[40]],
		"/(authed)/logout": [161,[2]],
		"/maintenance": [189],
		"/(authed)/private": [162,[2,34]],
		"/(authed)/private/administration": [163,[2,34,35]],
		"/(authed)/private/administration/invites": [164,[2,34,35]],
		"/(authed)/private/administration/usage": [165,[2,34,35]],
		"/(authed)/private/cases": [166,[2,34]],
		"/(authed)/private/cases/[case_id]": [167,[2,34,36]],
		"/(authed)/private/clients": [168,[2,34]],
		"/(authed)/private/clients/[client_id]": [169,[2,34,37]],
		"/(authed)/private/clients/[client_id]/events": [170,[2,34,37]],
		"/(authed)/private/clients/[client_id]/workflows/cases": [171,[2,34,37]],
		"/(authed)/private/clients/[client_id]/workflows/documents": [172,[2,34,37]],
		"/(authed)/private/clients/[client_id]/workflows/elm": [173,[2,34,37]],
		"/(authed)/private/clients/[client_id]/workflows/records": [174,[2,34,37]],
		"/(authed)/private/clients/[client_id]/workflows/validations": [175,[2,34,37]],
		"/(authed)/private/system": [176,[2,34,38]],
		"/(authed)/private/system/base_job_details": [177,[2,34,38]],
		"/(authed)/private/system/base_jobs": [178,[2,34,38]],
		"/(authed)/private/system/jobs": [179,[2,34,38]],
		"/skv": [190],
		"/visma": [191]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);